import { componentResolverFromMap } from "gatsby-plugin-prismic-previews";

import { linkResolver } from "./link-resolver";

import BlogDetailsPage from "../../src/pages/blog-details/{prismicBlog.uid}";
import PortfolioDetailsPage from "../../src/pages/portfolios-details/{prismicPortfolio.uid}";
import PressDetailsPage from "../../src/pages/press-details/{prismicPress.uid}";

/**
 * Prismic preview configuration for each repository in your app. This set of
 * configuration objects will be used with the `PrismicPreviewProvider`
 * higher order component.
 *
 * If your app needs to support multiple Prismic repositories, add each of
 * their own configuration objects here as additional elements.
 *
 */
export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    linkResolver,
    componentResolver: componentResolverFromMap({
      blog: BlogDetailsPage,
      portfolio: PortfolioDetailsPage,
      press: PressDetailsPage,
      // Add more mappings as needed for other templates
    }),
  },
];